export const linkVoid = (e) => {
    e.preventDefault();
};

export const arrayMove = (arr, from, to) => {
    const localArr = [...(arr || [])];

    if (to >= localArr.length) {
        let k = to - localArr.length + 1;
        while (k--) {
            localArr.push(undefined);
        }
    }

    localArr.splice(to, 0, localArr.splice(from, 1)[0]);

    return localArr;
};

export const isArray = a => Array.isArray(a);

export const isObject = o => o === Object(o) && !isArray(o) && typeof o !== "function";

export const cleanObject = (o, emptyIsNull) => {
    if (!isObject(o)) return;

    const localO = { ...o };
    const keys = Object.keys(o);

    keys.forEach((key) => {
        if (localO[key] === null ||
          localO[key] === undefined ||
          (emptyIsNull && localO[key]?.trim() === "")
        ) {
            delete localO[key];
        }
    });

    return localO;
};

export const findAddress = (addresses, { firstName, lastName, phoneNumber, email, faxNumber, company, address1, address2, city, county, stateProvinceId, zipPostalCode, countryId }) => {
    return addresses.find((a) => ((!a.firstName && !firstName) || a.firstName === firstName) &&
      ((!a.lastName && !lastName) || a.lastName === lastName) &&
      ((!a.phoneNumber && !phoneNumber) || a.phoneNumber === phoneNumber) &&
      ((!a.email && !email) || a.email === email) &&
      ((!a.faxNumber && !faxNumber) || a.faxNumber === faxNumber) &&
      ((!a.company && !company) || a.company === company) &&
      ((!a.address1 && !address1) || a.address1 === address1) &&
      ((!a.address2 && !address2) || a.address2 === address2) &&
      ((!a.city && !city) || a.city === city) &&
      ((!a.county && !county) || a.county === county) &&
      ((a.stateProvinceId === null && (stateProvinceId === null || stateProvinceId === 0)) || (a.stateProvinceId !== null && a.stateProvinceId === stateProvinceId)) &&
      ((!a.zipPostalCode && !zipPostalCode) || a.zipPostalCode === zipPostalCode) &&
      ((a.countryId === null && countryId === null) || (a.countryId !== null && a.countryId === countryId)));
};
